import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class HUD extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        let difficultyStr: string;

        switch (GameVars.difficulty) {

            case GameConstants.DIFFICULTY_EASY:
                difficultyStr = "1";
                break;
            case GameConstants.DIFFICULTY_NORMAL:
                difficultyStr = "2";
                break;
            case GameConstants.DIFFICULTY_HERO:
                difficultyStr = "3";
                break;

            default:
        }

        const levelLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 60 * GameVars.scaleY, difficultyStr + " - " + GameVars.currentLevel, {fontFamily: "Bubblegum", fontSize: "65px", color: "#035B80"});
        levelLabel.setOrigin(.5);
        levelLabel.scaleY = GameVars.scaleY;
        this.add(levelLabel);
    }

    public hide(): void {

        this.scene.tweens.add({
            targets: this,
            y: -120,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
        });
    }

    public show(): void {

        this.scene.tweens.add({
            targets: this,
            y: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
        });
    }
}
